/* BUDS — Flashy renders its popup email input with autocomplete="new-password",
   which blocks browser / iOS email autofill. Restore proper email hints inside
   <flashy-popup> shadow roots. Only sets attributes: never removes, hides or
   re-renders popups, and never touches form submits. */
(function () {
  'use strict';

  var EMAIL_HINTS = { autocomplete: 'email', inputmode: 'email', autocapitalize: 'off', spellcheck: 'false' };

  function fixInputs(root) {
    var inputs = root.querySelectorAll('input[type="email"], input[name="email"]:not([type="hidden"])');
    for (var i = 0; i < inputs.length; i++) {
      for (var key in EMAIL_HINTS) {
        if (inputs[i].getAttribute(key) !== EMAIL_HINTS[key]) inputs[i].setAttribute(key, EMAIL_HINTS[key]);
      }
    }
  }

  function watchPopup(host, tries) {
    if (host.__budsFields) return;
    var root = host.shadowRoot;
    if (!root) {
      tries = tries || 0;
      if (tries < 60) requestAnimationFrame(function () { watchPopup(host, tries + 1); });
      return;
    }
    host.__budsFields = true;
    fixInputs(root);
    // Each popup screen is re-rendered into the same shadow root.
    new MutationObserver(function () { fixInputs(root); }).observe(root, { childList: true, subtree: true });
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.nodeName === 'FLASHY-POPUP') return watchPopup(node);
    if (!node.firstElementChild) return;
    var nested = node.getElementsByTagName('flashy-popup');
    for (var i = 0; i < nested.length; i++) watchPopup(nested[i]);
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document.documentElement);
})();
